import React from 'react';

export const RicosDevToolsLazy = React.lazy(
  () => import(/* webpackChunkName: "ricos-dev-tools" */ './RicosDevTools.js')
);
